module.exports = __webpack_public_path__ + "img/arrow-left_s.3a127055.svg";